import { TS_Room }              from '../TravelSeller/Models/TS_Room';
import { BookingItemInterface } from './BookingItemInterface';

export class Room extends TS_Room implements BookingItemInterface {}